/* js/moreText.js */

jQuery( document ).ready(function( $ ) {

    $('.js-moreText-trigger').click(function (e) {
        e.preventDefault();
        $(this).closest('.js-moreText').toggleClass('js-moreText-active');


        var txt = $(".js-moreText-full").is(':visible') ? 'Less' : 'More';
        $(this).text(txt);


    });







});